export const updateSelectedCollegeId = (value) => ({
    type: 'UPDATE_SELECTED_COLLEGE_ID',
    value,
});

export const updateTableDataType = (value) => ({
    type: 'UPDATE_TABLE_DATA_TYPE',
    value,
});

export const updateDetailsSectionVisible = (value) => ({
    type: 'UPDATE_DETAILS_SECTION_VISIBLE',
    value,
});
